import RestClientService from 'Services/RestClientService';

class MasterDataApiService {
  static async getSourceMarkets() {
    return RestClientService.GetFromGpx('masterdata/source-market');
  }

  static async getJobFamilies() {
    return RestClientService.GetFromGpx('masterdata/job-family');
  }

  static async getJobTitles() {
    return RestClientService.GetFromGpx('masterdata/job-title');
  }

  static async getPositionTypes() {
    return RestClientService.GetFromGpx('masterdata/mpl-position-type');
  }

  static async getSeasons() {
    return RestClientService.GetFromGpx('masterdata/season');
  }

  static async getCountries() {
    return RestClientService.GetFromGpx('masterdata/country');
  }

  static async getRegions() {
    return RestClientService.GetFromGpx('masterdata/region');
  }

  static async getDestinations() {
    return RestClientService.GetFromGpx('masterdata/destination');
  }

  static async getKeywords() {
    return RestClientService.GetFromGpx('setting/keywords');
  }

  static async getMplids() {
    return RestClientService.GetFromGpx('masterdata/mplid');
  }

  static async getStaffStatus() {
    return RestClientService.GetFromGpx('masterdata/staff-status');
  }

  static async getStaffNationalities() {
    return RestClientService.GetFromGpx('masterdata/staff-nationalies');
  }

  static async getLanguages() {
    return RestClientService.GetFromGpx('masterdata/language');
  }

  static async getLanguageLevels() {
    return RestClientService.GetFromGpx('masterdata/language-level');
  }
}

export default MasterDataApiService;
